export const experiences = [
    {
        title: `Co-op at Cineplex Digital Media as junior software developer`,
        years: `2019-2020`,
        desc: `This was my first real dive into the software engineering industry. I was introduced to the development workflow, and the basic production cycle.

      I worked on a wide variety of projects from web design to working on custom applications. I learned how to use ReactJS, and improved my HTML/CSS skills as well as my general Javascript skills. `,
    },
    {
        title: `Waterloo University CCC contests`,
        years: `2018-2021`,
        desc: `Waterloo University holds annual computing contests for students that tests programming and logical skills. Every year I participated, I received the Certificate of Distinction (Top 25% of participants).
      
      For these contests, the main languages that I used were Java and Python.`,
    },
    {
        title: `Hobbyist Game Development`,
        years: "2020-2021",
        desc: `I picked up game development as a hobby during 2020 quarantine. I have dabbled with various frameworks and engines like LibGDX and PixiJS, but I eventually settled on Unity, which uses C#. I wasn't familiar with C# initially, but I quickly picked it up because of its similarities to Java.`,
    },
    {
        title: `Hopefully more!`,
        years: `2021-the future`,
        desc: `I'm still learning, and I am always looking for more opportunities to improve my skills.`,
    },
];
